export const parseDelimitedText = (text) => {
    const commaCount = (text.match(/,/g) || []).length;
    const tabCount = (text.match(/\t/g) || []).length;
    const delimiter = commaCount > tabCount ? ',' : '\t';
    
    const rows = text.split('\n').filter(row => row.trim()).map(row => {
        const cells = [];
        let inQuotes = false;
        let currentCell = '';
        
        for (let i = 0; i < row.length; i++) {
            const char = row[i];
            if (char === '"') {
                inQuotes = !inQuotes;
            } else if (char === delimiter && !inQuotes) {
                cells.push(currentCell.trim());
                currentCell = '';
            } else {
                currentCell += char;
            }
        }
        cells.push(currentCell.trim());
        return cells;
    });

    return rows;
};

export const getUniqueValues = (field, headers, locations) => {
    const index = headers.indexOf(field);
    if (index === -1) return [];
    return [...new Set(locations.map(loc => loc.data[index]))];
};
